var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.images.length)?_c('slider',{ref:"slider",staticClass:"b-gallery",attrs:{"slides":_vm.data.images,"zoom":true,"showIndex":true,"options":{
        wrapAround: true,
        draggable: true,
    }},scopedSlots:_vm._u([{key:"slide",fn:function(image){return [_c('asset',{attrs:{"asset":image},on:{"loaded":function($event){return _vm.refreshSlider()}}})]}}],null,false,763158317)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }